import { render, staticRenderFns } from "./CompanyAnnouncementsDetails.vue?vue&type=template&id=6d292e64&scoped=true"
import script from "./CompanyAnnouncementsDetails.vue?vue&type=script&lang=js"
export * from "./CompanyAnnouncementsDetails.vue?vue&type=script&lang=js"
import style0 from "./CompanyAnnouncementsDetails.vue?vue&type=style&index=0&id=6d292e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d292e64",
  null
  
)

export default component.exports